import { useQueryClient } from '@tanstack/react-query'

import { adminDashboardQueryKeys } from './adminDashboardQueryKeys'

const useAdminDashboardQueryInvalidation = () => {
  const queryClient = useQueryClient()

  return {
    invalidateAdminDashboardList: () => queryClient.invalidateQueries({ queryKey: adminDashboardQueryKeys.all }),
    invalidateAdminDashboardDetail: (dashboardId: string) =>
      queryClient.invalidateQueries({ queryKey: adminDashboardQueryKeys.detail(dashboardId) }),
  }
}

export default useAdminDashboardQueryInvalidation
